<template lang="pug">
v-container(fluid)
  a(href="" id="exportLink" ref="exportLink" hidden)
  v-card(class="mb-5")
    v-form
      v-row(class="px-2")
        v-col(class="d-flex" cols="12" md="8")
          v-text-field(
            class="mr-5"
            v-model="npn"
            clearable
            label="Número predial o Número predial anterior"
            required)
          v-select(
            style="z-index: 400"
            :items="cadastralBases"
            item-value="codigo"
            item-text="nombre"
            v-model="selectedBase"
            clearable
            label="Seleccione la base catastral"
            required)
          v-text-field(
            class="ml-4"
            v-model="buffer"
            clearable
            label="Esfecifique un buffer en metros"
            required)
        v-col
          v-btn(
            :disabled="loading"
            :loading="loading"
            color="green"
            small
            class="ma-2 white--text"
            @click="search")
            v-icon(left dark) mdi-magnify
            | consultar
          v-btn(
            :disabled="loading"
            :loading="loading"
            color="red"
            small
            class="ma-2 white--text"
            @click="clear")
            v-icon(left dark) mdi-broom
            | limpiar
  v-row(dense)
    v-card(class="mx-auto" max-width="100%" width="100%")
      l-map(
        id="mapAdjoiningContent"
        :zoom="zoom"
        :options="mapOptions"
        ref="myMap"
        :center="center"
        @click="mapClick"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
        @ready="lefletMapReady()"
        :style="{height: '350px', width: '100%'}")
        //- control de las capas del mapa
        l-control-layers(ref="lyControl")
        //- control pantalla completa
        l-control-fullscreen(
          position="topleft"
          :options="fullscreenOptions")
        //- control para la busqueda geografica
        geo-search-control(
          v-if="map !== null"
          :map="map")
        //- control para imprimir el mapa
        print-map-control(
          v-if="map !== null"
          :map="map")
        //- COntrool para cargar imagenes georreferenciadas
        load-geotiff-control(v-if="map !== null")
        //- Control para cargar datos vectoriales
        load-vector-control(v-if="map !== null" :list-layers="vectorLayers")
        //- control para enfocar el cruce
        l-control(
          v-if="cadastralAdjacencyResult !== null"
          class="ark-lf-custom-control clickable"
          title="Encuadrar Predios")
          v-icon(
            class="pt-1 pl-1"
            size="35"
            @click="focusEstates"
            color="grey darken-1"
            ) mdi-target
        //- control desacargar poligonos colindantes
        l-control(
          v-if="cadastralAdjacencyResult !== null"
          class="ark-lf-custom-control clickable"
          title="Descargar los datos geográficos del cruce (KML)")
          v-icon(
            class="pt-1 pl-1"
            size="35"
            @click="getKLM"
            color="grey darken-1"
            ) mdi-file-download
        //- capas base y superpuestas del mapa
        l-wms-tile-layer(
          v-for="l in layers"
          :key="l.name"
          :base-url="l.url"
          :layer-type="l.type"
          :layers="l.layers"
          :transparent="l.transparent"
          format="image/png"
          :name="l.name"
          :visible="l.visible")
        //- Poligonos de los predios con colindancia
        l-geo-json(
          :options="options"
          :options-style="styleFunctionEstates"
          ref="estatesLayer"
          :geojson="estatesAdjoiningGeojson")
      v-card-title
        | Folio Analizado
        v-spacer
        v-btn(
          @click="loadVurRecords(missingFolios)"
          :disabled="missingFolios.length === 0"
          class="orange mr-2"
          color="black"
          title="Descarga Vur de folios faltantes"
        ) Descargar Faltantes <b class="ml-2" style="font-size:22px">{{ missingFolios.length }}</b>
        v-btn(
          @click="loadVurRecords(validFolios)"
          :disabled="validFolios.length === 0"
          class="blue"
          color="black"
          title="Descarga Vur de todos los folios colindantes"
        ) Descargar Todos <b class="ml-2" style="font-size:22px">{{ validFolios.length }}</b>
        button-download-pdf(class="ml-2" :folios="avalaibleFolios")
        v-btn(
          @click="fillColorEstates()"
          :disabled="cadastralAdjacencyResult === null"
          class="green ml-2"
          color="black"
          title="Permite cambiar el color de los predios con polígono de forma masiva"
        )
          v-icon mdi-palette-outline
          | Pintar Predios
        v-btn(
          :loading="loading"
          @click="printReport()"
          :disabled="cadastralAdjacencyResult === null"
          class="green ml-2"
          color="black"
          title="Permite descargar un reporte preliminar en formato Word"
        )
          v-icon mdi-file-download-outline
          | Descargar Reporte
      v-row(class="pa-3" v-if="cadastralAdjacencyResult !== null")
        v-col(cols="12")
          cadastral-ajoining-item(
            :estate="current"
            :color="'red'"
            :horizontal="true"
          )
      div(class="text-center text-h6 font-weight-light" v-else) Sin resultados

      v-divider(class="mx-4")

      v-card-title
        | Folios Colindantes
        span(class="ml-3" v-if="cadastralAdjacencyResult !== null")
          | <b class="green--text text-h5">{{ adjoining.length }}</b> Predios Colindates
      v-row(class="pa-3" v-if="cadastralAdjacencyResult !== null")
        v-col(cols="3" v-for="folio in adjoining" :key="folio.codigo")
          cadastral-ajoining-item(
            :estate="folio"
            :animate="focusedEstate === folio.codigo"
          )
      div(class="text-center text-h6 font-weight-light" v-else) Sin resultados
</template>

<script>
import tokml from 'tokml';
import { mapState, mapActions, mapMutations } from 'vuex';
import mapMixin from '@/mixins/mapMixin.js';
import folioMixin from '@/mixins/folioMixin.js';
import {
  LMap,
  LWMSTileLayer,
  LControlLayers,
  LControl,
  LControlScale,
  LGeoJson,
  LMarker,
  LPolygon,
  LTooltip,
} from "vue2-leaflet";
import CadastralAjoiningItem from '@/components/cadastral/CadastralAjoiningItem.vue';
import GeoSearchControl from '@/components/geos/GeoSearchControl.vue';
import ButtonDownloadPdf from '@/components/files/ButtonDownloadPdf';
import LControlFullscreen from 'vue2-leaflet-fullscreen';
import PrintMapControl from '@/components/geos/PrintMapControl.vue';
import L from 'leaflet';
import html2canvas from "html2canvas";
import { arkandhaGeoserverUrl } from '@/env';
import LoadVectorControl from '@/components/geos/LoadVectorControl.vue';
import LoadGeotiffControl from '@/components/geos/LoadGeotiffControl.vue';

export default {
  name: 'CadastralComparisonManager',

  components: {
    LMap,
    LControlLayers,
    'l-wms-tile-layer': LWMSTileLayer,
    LControl,
    LControlScale,
    LGeoJson,
    LMarker,
    LPolygon,
    LTooltip,
    CadastralAjoiningItem,
    GeoSearchControl,
    ButtonDownloadPdf,
    LControlFullscreen,
    PrintMapControl,
    LoadVectorControl,
    LoadGeotiffControl,
  },

  mixins: [mapMixin, folioMixin],

  props: {},

  emits: [],

  data() {
    return {
      // propiedad que indica que el componente esta cargando
      loading: false,
      // propiedad que al macena el npn actual o anterior
      npn: '',
      // propiedad con la base catastral seleccionada
      selectedBase: null,
      // buffer para realizar el cruce en metros
      buffer: 0,
      // propiedad con el predio seleccionado
      focusedEstate: ''
    };
  },

  computed: {
    ...mapState('cadastral', [
      'cadastralBases',
      'cadastralAdjacencyResult',
      'currentAdjacencyEstate',
      'estatesAdjoiningGeojson',
    ]),
    ...mapState('geos', ['layers']),
    // propieda computada para estilos de los predios de gestion inmobiliaria
    styleFunctionEstates() {
      return (feat) => ({
        weight: 3,
        color: 'black', // feat.properties.color,
        opacity: 1,
        fillColor: feat.properties.color,
        dashArray: '5, 5',
        fillOpacity: 0.5
      });
    },
    options() {
      return {
        onEachFeature: this.onEachFeatureAdjoining,
        renderer: L.canvas()
      };
    },
    // propiedad computada para información de predios
    onEachFeatureAdjoining() {
      return (feature, layer) => {
        const popupString = `
        <div><b>FMI:</b> ${feature.properties.fmi} </div>
        <div class="mb-2"><b>Código:</b> ${feature.properties.codigo} </div>
        <div style="color: #2196F3">haga clic para enfocar la información del predio </div>
        `;
        // layer.bindTooltip(popupString,
        //   { permanent: false, sticky: true });
        layer.bindPopup(popupString, { closeButton: false, offset: L.point(0, 0) });
        layer.bindTooltip(String(feature.properties.key), {
          permanent: true,
          direction: 'center', // otras opciones: 'top', 'bottom', 'left', 'right'
          className: 'adjoining-estate-label'
        });
        layer.on('mouseover', () => { layer.openPopup(); });
        layer.on('mouseout', () => { layer.closePopup(); });
        layer.on('click', async () => {
          this.focusedEstate = feature.properties.codigo;
          const el = document.getElementById(`estate-${feature.properties.codigo}`);
          el.scrollIntoView()
          await setTimeout(() => { this.focusedEstate = '' }, 5000);
        });
      };
    },
    // propiedad con los predios colindantes
    adjoining() {
      return this.cadastralAdjacencyResult.adjacencies.filter(
        (x) => x.codigo !== this.currentAdjacencyEstate && x.codigo_ant !== this.currentAdjacencyEstate
      );
    },
    // propiedad que devuelve el folio analizado
    current() {
      return this.cadastralAdjacencyResult.adjacencies.filter(
        (x) => x.codigo === this.currentAdjacencyEstate || x.codigo_ant === this.currentAdjacencyEstate
      )[0];
    },
    // propiedad con los folios faltantes
    missingFolios() {
      if (this.cadastralAdjacencyResult === null) return [];
      return this.cadastralAdjacencyResult.adjacencies.filter((x) => x.fmi !== null && x.fmi !== '' && x.folio_id === null)
        .map((x) => x.fmi);
    },
    // propiedad con todos los folios
    validFolios() {
      if (this.cadastralAdjacencyResult === null) return [];
      return this.cadastralAdjacencyResult.adjacencies.filter((x) => x.fmi !== null && x.fmi !== '')
        .map((x) => x.fmi);
    },
    // propiedad computada que indica los folios que estan en el sistema
    avalaibleFolios() {
      if (this.cadastralAdjacencyResult === null) return [];
      return this.cadastralAdjacencyResult.adjacencies.filter((x) => x.folio_id !== null && x.folio_id !== '')
        .map((x) => x.fmi);
    },
  },

  watch: {
    'cadastralAdjacencyResult.geojson': {
      async handler(newValue) {
        if (newValue === null || newValue === undefined) return;
        await setTimeout(() => {}, 200);
        if (this.$refs.estatesLayer === undefined) return;
        const layer = this.$refs.estatesLayer.mapObject;
        this.map.fitBounds(layer.getBounds());
      }
    }
  },

  async mounted() {
    if ('code' in this.$route.query) {
      let base = 'base' in this.$route.query ? this.$route.query.base : null;
      if (base === undefined) {
        base = null;
      }
      // Inicializar el numero de matricula inmobiliaria
      let { code } = this.$route.query;
      if (code === undefined) {
        code = '';
      }
      this.npn = code;
      this.selectedBase = base;
      // ejecutar la funcion de consulta
      if (this.selectedBase !== null) setTimeout(() => this.search(), 1000);
      // eliminar el parametro de la ruta
      window.history.replaceState({}, document.title, "/" + "cadastral_adjacency");
    }
    // llenar bases de datos catastrales
    await this.getCadastralBases();
    // Obtener los dominios catastrales
    await this.getCadastralDomains();
  },

  methods: {
    ...mapMutations('cadastral', ['CHANGE_VALUE', 'CLEAR_ADJOINING_GEOJSON']),
    ...mapMutations('files', {filesChangeValue: 'CHANGE_VALUE'}),
    ...mapMutations('ui', ['SHOW_ALERT']),
    ...mapActions('cadastral', [
      'getCadastralBases',
      'cadastralAdjacencySearch',
      'fillColorEstates',
      'adjoiningReport',
      'getCadastralDomains',
    ]),
    // metodo que consulta la equivalencia de los poligonos catastrales
    async search() {
      if (this.npn === '') {
        alert('Debe ingresar un valor.');
        return;
      }
      if (this.selectedBase === null) {
        alert('Debe seleccionar una base catastral.');
        return;
      }
      if ([null, undefined, ''].includes(this.buffer) || isNaN(this.buffer)) {
        alert('Deve tener un valor numerico');
        return;
      }
      this.loading = true;
      try {
        await this.cadastralAdjacencySearch({
          npn: this.npn,
          base: this.selectedBase,
          buffer: this.buffer
        });
      } catch (error) {
        this.SHOW_ALERT({
          alertMessage:'Ocurrio un error al cargar la información',
          alertType: 'error'
        });
      }  
      this.loading = false;
    },
    // metodo para limpiar la vista
    clear() {
      this.npn = '';
      this.selectedBase = null;
      // this.CLEAR_ADJOINING_GEOJSON();
      this.CHANGE_VALUE({
        value: null,
        varName: 'cadastralAdjacencyResult'
      });
      this.CHANGE_VALUE({
        value: null,
        varName: 'estatesAdjoiningGeojson'
      });
      this.filesChangeValue({
        value: '',
        varName: 'zipPath'
      });
    },
    // metodo para enfocar los predios colindantes
    focusEstates() {
      if (this.cadastralAdjacencyResult.geojson.features.length === 0) return;
      const layer = this.$refs.estatesLayer.mapObject;
      this.map.fitBounds(layer.getBounds());
    },
    // metodo para descaragar el KML de los cruces
    getKLM() {
      const data = this.$refs.estatesLayer.mapObject.toGeoJSON();
      // agregar los atributos al geojson
      let propertyData = {};
      data.features[0].properties = propertyData;
      var kml = tokml(data);

      var convertedData = 'application/xml;charset=utf-8,' + encodeURIComponent(kml);

      // if you want to use the official MIME type for KML
      // var convertedData = 'application/vnd.google-earth.kml+xml;charset=utf-8,' + 
      // encodeURIComponent(kml);
      const today = new Date();
      let formatDate = today.toISOString().replace('T', '_').replace('Z', '');
      formatDate = formatDate.slice(0, formatDate.length - 4);
      document.getElementById('exportLink').setAttribute('href', 'data:' + convertedData); 
      document.getElementById('exportLink').setAttribute('download',
        `predios_colindantes_${formatDate}.kml`);
      this.$refs.exportLink.click();
    },
    // metodo para ver info WMS
    mapClick(e) {
      // si no esta habilitado el dibujo consultar el serviscio WMS
      this.getFeatureInfo(
        e,
        null,
        arkandhaGeoserverUrl,
        ['codigo', 'codigo_ant', 'registros_1', 'registros_2']);
    },
    // metodo para imprimir el reporte de colindancia
    async printReport() {
      // const me = this;
      this.loading = true;
      // implementacion html o canvas
      const el = document.getElementById('mapAdjoiningContent');
      // ocultar controles
      el.classList.add("ark-lf-hidden-controls");
      // opciones de impresion.
      const options = {
        type: 'dataURL',
        // allowTaint: true,
        useCORS: true,
      };
      const screenShot = await html2canvas(el, options);
      const image = screenShot.toDataURL("image/png");
      // remover clase clase
      el.classList.remove("ark-lf-hidden-controls");
      const resp = await this.adjoiningReport(image);
      if (resp.obtained) {
        const fileContent = resp.report;
        const link = document.createElement('a');
        const blob = new Blob([Uint8Array.from(atob(fileContent), (c) => c.charCodeAt(0))], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = 'reporte_colindancia.docx'; // Nombre del archivo descargado
        link.click();
        window.URL.revokeObjectURL(url);
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>
</style>
